import { SubscriptionPlanIntervalEnum } from 'common/enums/SubscriptionPlanIntervalEnum'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

type LimitedSubscriptionPlanProps = {
  amountWithCurrency: string
  interval: SubscriptionPlanIntervalEnum
  intervalCount: number
  limitOfPayments: number
} & (
  | {
      trialInterval: SubscriptionPlanIntervalEnum
      trialPeriod: number
    }
  | {
      trialInterval?: never
      trialPeriod?: never
    }
)

function LimitedSubscriptionPlan({
  amountWithCurrency,
  trialInterval,
  trialPeriod,
  interval,
  intervalCount,
  limitOfPayments,
}: LimitedSubscriptionPlanProps) {
  const { t } = useTypedTranslation(['common', 'publisher'])

  let readableAmount = ''
  if (trialPeriod) {
    const interval = t(`price_plan.trial_period.${trialInterval}_icu`, {
      count: trialPeriod,
    })
    readableAmount = `${t(
      'components.offer_price.price_plans.trial_period_new_icu',
      {
        trialPeriodPrice: t(
          'components.offer_price.price_plans.trial_period_price',
        ),
        trialInterval: interval,
      },
    )} `
  }
  // readableAmount += t('components.offer_price.price_plans.limited_icu', {
  //   amount: amountWithCurrency,
  //   interval: t(`price_plan.interval.${interval}_icu`, {
  //     count: intervalCount,
  //   }),
  //   intervalWithLimitOfPayments: t(`price_plan.interval.${interval}_icu`, {
  //     count: limitOfPayments * intervalCount,
  //   }),
  // })

  readableAmount += t(
    'components.offer_price.price_plans.limited_with_limit_of_payments_icu',
    {
      count: limitOfPayments,
      amount: amountWithCurrency,
      interval: t(`price_plan.interval.${interval}_icu`, {
        count: intervalCount,
      }),
    },
  )

  return <>{readableAmount}</>
}

export default LimitedSubscriptionPlan
